export default __webpack_public_path__ + "static/media/GitHub_Logo.746ec8f0.png";